import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import css from './PromoCodesListComponent.module.css';
import {ButtonsArrowsFilter} from "../../../ui";
import {promoCodesActions} from "../../../store/slices/settings-slices";
import PromoCodeComponent from "../PromoCodeComponent/PromoCodeComponent";


const PromoCodesListComponent = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {promoCodesArray, trigger} = useSelector(store => store.promoCodes);
    const [sortedData, setSortedData] = useState([]);

    useEffect(() => {
        dispatch(promoCodesActions.getAllPromoCodes());
    }, [trigger]);

    useEffect(() => {
        setSortedData(promoCodesArray);
    }, [promoCodesArray]);


    const sortData = (key, direction) => {
        const sorted = [...promoCodesArray].sort((a, b) => {
            if (direction === 'asc') {
                return a[key] > b[key] ? 1 : -1;
            } else {
                return a[key] < b[key] ? 1 : -1;
            }
        });
        setSortedData(sorted);
    };


    const filterPromoCodeUp = () => sortData('promoCode', 'asc');
    const filterPromoCodeDown = () => sortData('promoCode', 'desc');
    const filterValidFromUp = () => sortData('validFrom', 'asc');
    const filterValidFromDown = () => sortData('validFrom', 'desc');
    const filterValidToUp = () => sortData('validUntil', 'asc');
    const filterValidToDown = () => sortData('validUntil', 'desc');


    return (
        <section className={css.wrap}>
            <section className={css.header}>
                <div className={css.promoCode}>
                    <div>{t('Promo-code')}</div>
                    <div>
                        <ButtonsArrowsFilter
                            onButtonUpClick={filterPromoCodeUp}
                            onButtonDownClick={filterPromoCodeDown}
                        />
                    </div>
                </div>

                <div className={css.validFrom}>
                    <div>{t('Valid-from')}</div>
                    <div>
                        <ButtonsArrowsFilter
                            onButtonUpClick={filterValidFromUp}
                            onButtonDownClick={filterValidFromDown}
                        />
                    </div>
                </div>

                <div className={css.validTo}>
                    <div>{t('Valid-to')}</div>
                    <div>
                        <ButtonsArrowsFilter
                            onButtonUpClick={filterValidToUp}
                            onButtonDownClick={filterValidToDown}
                        />
                    </div>
                </div>

                <div className={css.staffDescription}>{t('Staff-description')}</div>
                <div className={css.actions}>{t('Actions')}</div>
            </section>

            {sortedData && sortedData.map((obj) => (
                <PromoCodeComponent key={obj.id} promoCodeObj={obj}/>
            ))}
        </section>
    );
};

export default React.memo(PromoCodesListComponent);
